import {
  executeStatefulServerSideGuards,
  executeStatelessServerSideGuards,
} from '../helper/executeServerSideGuards';
import { generateInitialServerSideGuards } from './account/generateInitialServerSideGuards';
import { generateRouteServerSideGuards } from './account/generateRouteServerSideGuards';
import { INITIAL_DEFAULT_STATE, ROUTE_DEFAULT_STATE } from './account/state';

import type { GetServerSidePropsContext } from 'next';
import type { GetServerSidePropsWrapperProps } from '../../types';

export const getServerSidePropsAccountWrapper = (props?: GetServerSidePropsWrapperProps) => {
  const { serviceInitialGuards = [], serviceRouteGuards = [] } = props ?? {};

  const initialGuards = generateInitialServerSideGuards(serviceInitialGuards);
  const routeGuards = generateRouteServerSideGuards(serviceRouteGuards);

  return async (context: GetServerSidePropsContext) => {
    const { req } = context;
    const { url = '' } = req;
    const isInitial = !url.startsWith('/_next/data');

    if (isInitial) {
      return await executeStatefulServerSideGuards({
        context,
        guards: initialGuards,
        state: INITIAL_DEFAULT_STATE,
      });
    } else {
      return await executeStatelessServerSideGuards({
        context,
        guards: routeGuards,
        state: ROUTE_DEFAULT_STATE,
      });
    }
  };
};
